import React from 'react';

const ServicesSection = () => {
  return (
    <div className="max-w-6xl mx-auto px-4 py-16">
      {/* Heading */}
      <div className="mb-8">
        <h2 className="text-4xl font-bold text-center">
          <span className="text-gray-900">Optimized Business </span>
          <span className="text-blue-500">Solutions</span>
        </h2>
      </div>

      {/* Introduction Text */}
      <div className="mb-16">
        <p className="text-gray-800 text-center max-w-5xl mx-auto">
          Our comprehensive suite of BPO, healthcare, and digital marketing solutions provides seamless and optimized services that elevate our clients' operations. With over a decade of experience and a proven track record of success, we strive to inspire and empower our clients to achieve their goals and drive sustainable growth.
        </p>
      </div>

      {/* Services Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        {/* Business Process Outsourcing */}
        <div className="border border-gray-200 p-8 rounded">
          <div className="flex items-start mb-6">
            <div className="mr-4">
              <div className="w-12 h-12 text-blue-600">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                  <circle cx="12" cy="12" r="3" />
                  <circle cx="12" cy="4" r="1.5" />
                  <circle cx="12" cy="20" r="1.5" />
                  <circle cx="4" cy="12" r="1.5" />
                  <circle cx="20" cy="12" r="1.5" />
                </svg>
              </div>
            </div>
            <div>
              <h3 className="text-2xl font-bold text-gray-900">Business Process Outsourcing</h3>
            </div>
          </div>
          <div className="ml-16">
            <p className="mb-4 text-gray-700">
              Our BPO call center department provides top-notch customer support.
            </p>
            <ul className="space-y-2">
              <li className="flex items-center text-gray-700">
                <span className="text-blue-500 mr-2">→</span> Inbound Calls
              </li>
              <li className="flex items-center text-gray-700">
                <span className="text-blue-500 mr-2">→</span> Outbound Calls
              </li>
              <li className="flex items-center text-gray-700">
                <span className="text-blue-500 mr-2">→</span> Email and Chat Support
              </li>
              <li className="flex items-center text-gray-700">
                <span className="text-blue-500 mr-2">→</span> SMS Support
              </li>
            </ul>
          </div>
        </div>

        {/* Health Care */}
        <div className="border border-gray-200 p-8 rounded">
          <div className="flex items-start mb-6">
            <div className="mr-4">
              <div className="w-12 h-12 text-blue-600">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 2c-5.5 0-10 4.5-10 10s4.5 10 10 10 10-4.5 10-10-4.5-10-10-10zm-2 15l-5-5 1.4-1.4 3.6 3.6 7.6-7.6 1.4 1.4-9 9z" />
                </svg>
              </div>
            </div>
            <div>
              <h3 className="text-2xl font-bold text-gray-900">Health Care</h3>
            </div>
          </div>
          <div className="ml-16">
            <p className="mb-4 text-gray-700">
              Managing patient billing and processing insurance claims are part of it.
            </p>
            <ul className="space-y-2">
              <li className="flex items-center text-gray-700">
                <span className="text-blue-500 mr-2">→</span> Medical Billing
              </li>
              <li className="flex items-center text-gray-700">
                <span className="text-blue-500 mr-2">→</span> Medical Transcription
              </li>
              <li className="flex items-center text-gray-700">
                <span className="text-blue-500 mr-2">→</span> Management Services
              </li>
            </ul>
          </div>
        </div>

        {/* Digital Marketing */}
        <div className="border border-gray-200 p-8 rounded">
          <div className="flex items-start mb-6">
            <div className="mr-4">
              <div className="w-12 h-12 text-blue-600">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z" />
                </svg>
              </div>
            </div>
            <div>
              <h3 className="text-2xl font-bold text-gray-900">Digital Marketing</h3>
            </div>
          </div>
          <div className="ml-16">
            <p className="mb-4 text-gray-700">
              Our digital marketing team helps businesses reach their target audience.
            </p>
            <ul className="space-y-2">
              <li className="flex items-center text-gray-700">
                <span className="text-blue-500 mr-2">→</span> Graphic Designing
              </li>
              <li className="flex items-center text-gray-700">
                <span className="text-blue-500 mr-2">→</span> Search Engine Optimization
              </li>
              <li className="flex items-center text-gray-700">
                <span className="text-blue-500 mr-2">→</span> Social Media Marketing
              </li>
              <li className="flex items-center text-gray-700">
                <span className="text-blue-500 mr-2">→</span> Content Writing
              </li>
            </ul>
          </div>
        </div>

        {/* Software Development */}
        <div className="border border-gray-200 p-8 rounded">
          <div className="flex items-start mb-6">
            <div className="mr-4">
              <div className="w-12 h-12 text-blue-600">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M19.14 12.94c.04-.3.06-.61.06-.94 0-.32-.02-.64-.07-.94l2.03-1.58c.18-.14.23-.41.12-.61l-1.92-3.32c-.12-.22-.37-.29-.59-.22l-2.39.96c-.5-.38-1.03-.7-1.62-.94l-.36-2.54c-.04-.24-.24-.41-.48-.41h-3.84c-.24 0-.43.17-.47.41l-.36 2.54c-.59.24-1.13.57-1.62.94l-2.39-.96c-.22-.08-.47 0-.59.22l-1.92 3.32c-.12.22-.07.47.12.61l2.03 1.58c-.05.3-.09.63-.09.94s.02.64.07.94l-2.03 1.58c-.18.14-.23.41-.12.61l1.92 3.32c.12.22.37.29.59.22l2.39-.96c.5.38 1.03.7 1.62.94l.36 2.54c.05.24.24.41.48.41h3.84c.24 0 .44-.17.47-.41l.36-2.54c.59-.24 1.13-.56 1.62-.94l2.39.96c.22.08.47 0 .59-.22l1.92-3.32c.12-.22.07-.47-.12-.61l-2.01-1.58zM12 15.6c-1.98 0-3.6-1.62-3.6-3.6s1.62-3.6 3.6-3.6 3.6 1.62 3.6 3.6-1.62 3.6-3.6 3.6z"/>
                </svg>
              </div>
            </div>
            <div>
              <h3 className="text-2xl font-bold text-gray-900">Software Development</h3>
            </div>
          </div>
          <div className="ml-16">
            <p className="mb-4 text-gray-700">
              Empowering Your Vision with Expert Software/Web Development Services.
            </p>
            <ul className="space-y-2">
              <li className="flex items-center text-gray-700">
                <span className="text-blue-500 mr-2">→</span> Web Development
              </li>
              <li className="flex items-center text-gray-700">
                <span className="text-blue-500 mr-2">→</span> UI/UX Designing
              </li>
              <li className="flex items-center text-gray-700">
                <span className="text-blue-500 mr-2">→</span> Wordpress Development
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServicesSection;